module.exports = __webpack_public_path__ + "img/Wechat_128px_1230528.ff737c05.png";